// src/components/student/VideoCard.js
import React, { useState } from "react";

export default function VideoCard({ video, onClick, watched = false }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onClick={() => onClick(video)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "var(--sp-white)",
        borderRadius: "var(--radius-lg)",
        border: hovered ? "1px solid rgba(255,214,0,0.5)" : "1px solid var(--sp-border)",
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        transform: hovered ? "translateY(-4px)" : "none",
        boxShadow: hovered ? "0 12px 40px rgba(0,0,0,0.12), 0 0 0 1px rgba(255,214,0,0.15)" : "var(--shadow-sm)"
      }}
    >
      {/* Thumbnail */}
      <div style={{ position: "relative", paddingTop: "56.25%", background: "#111", overflow: "hidden" }}>
        <img
          src={video.thumbnail}
          alt={video.title}
          style={{
            position: "absolute", inset: 0,
            width: "100%", height: "100%",
            objectFit: "cover",
            transition: "transform 0.4s ease",
            transform: hovered ? "scale(1.04)" : "scale(1)"
          }}
          onError={e => { e.target.style.display = "none"; }}
        />

        {/* Dark overlay on hover */}
        <div style={{
          position: "absolute", inset: 0,
          background: "rgba(0,0,0,0.3)",
          opacity: hovered ? 1 : 0,
          transition: "opacity 0.25s ease",
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>
          <div style={{
            width: 52, height: 52, borderRadius: "50%",
            background: "var(--sp-yellow)",
            display: "flex", alignItems: "center", justifyContent: "center",
            transform: hovered ? "scale(1)" : "scale(0.7)",
            transition: "transform 0.25s ease 0.05s",
            boxShadow: "var(--shadow-yellow)"
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <polygon points="5,3 19,12 5,21" fill="var(--sp-black)"/>
            </svg>
          </div>
        </div>

        {/* Duration badge */}
        <div style={{
          position: "absolute", bottom: 8, right: 8,
          background: "rgba(0,0,0,0.82)",
          color: "#fff", fontSize: 11, fontWeight: 600,
          padding: "2px 8px", borderRadius: 4, letterSpacing: "0.03em"
        }}>
          {video.duration}
        </div>

        {/* Category tag */}
        <div style={{
          position: "absolute", top: 8, left: 8,
          background: "var(--sp-yellow)",
          color: "var(--sp-black)", fontSize: 10, fontWeight: 700,
          padding: "3px 9px", borderRadius: 99, letterSpacing: "0.06em",
          textTransform: "uppercase"
        }}>
          {video.category}
        </div>

        {/* Watched badge */}
        {watched && (
          <div style={{
            position: "absolute", top: 8, right: 8,
            background: "var(--sp-green)",
            color: "#fff", fontSize: 10, fontWeight: 700,
            padding: "3px 9px", borderRadius: 99, display: "flex", alignItems: "center", gap: 4
          }}>
            <span>✓</span> Watched
          </div>
        )}
      </div>

      {/* Content */}
      <div style={{ padding: "14px 16px 16px" }}>
        <h3 style={{
          fontSize: 14, fontWeight: 700, color: "var(--sp-black)",
          lineHeight: 1.4, marginBottom: 8,
          display: "-webkit-box", WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical", overflow: "hidden"
        }}>
          {video.title}
        </h3>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <div style={{
              width: 24, height: 24, borderRadius: "50%",
              background: "var(--sp-yellow-light)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 10, fontWeight: 700, color: "var(--sp-black)"
            }}>
              {video.instructor?.[4]?.toUpperCase() || "S"}
            </div>
            <span style={{ fontSize: 12, color: "var(--sp-gray-mid)", fontWeight: 500 }}>
              {video.instructor}
            </span>
          </div>
          <span style={{ fontSize: 11, color: "var(--sp-gray-mid)" }}>
            {Number(video.views).toLocaleString()} views
          </span>
        </div>
      </div>
    </div>
  );
}
